import React from 'react'

interface AdminModeButtonProps {
    adminMode: boolean
    onToggle: () => void
}

export default function AdminModeButton({ adminMode, onToggle }: AdminModeButtonProps) {
    return (
        <button
            type="button"
            className={"btn btn-sm mr-3 " + (adminMode ? "btn-eseller-color" : "btn-outline-secondary")}
            onClick={onToggle}
        >
            <i className="fa fa-cog mr-1"/>Mode admin
        </button>
    )
}
